var swiper = new Swiper(".mySwiper", {
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  loop: true,
  speed: 1000, // Smooth transition speed (in milliseconds)
  effect: 'slide', // Default smooth slide effect
  grabCursor: true, // Adds a grab cursor for a smoother interaction feel
});


var swiper = new Swiper(".testimonialSwiper", {
  cssMode: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  autoplay: {
    delay: 8000,
    disableOnInteraction: false,
  },
  loop: true,
});

document.querySelector('.close-announcement-bar').addEventListener('click', () => {
  const utilityBar = document.querySelector('.utility-bar');
  if (utilityBar) {
    utilityBar.classList.add('hide');
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const petNameInput = document.getElementById('pet_name');
  const hiddenPetNameInput = document.getElementById('hidden_pet_name');
  if (petNameInput) {
    petNameInput.addEventListener('input', () => {
      hiddenPetNameInput.value = petNameInput.value;
    });
  }
});



document.addEventListener('DOMContentLoaded', () => {
  const shortDescription = document.querySelector('.product-description-short');
  const fullDescription = document.querySelector('.product-description-full');
  const readMoreButton = document.querySelector('.readmore');
  const readLessButton = document.querySelector('.readless');

  if (shortDescription && fullDescription) {
    fullDescription.style.display = 'none';
    if (readMoreButton) {
      readMoreButton.addEventListener('click', (event) => {
        event.preventDefault();
        shortDescription.style.display = 'none';
        fullDescription.style.display = 'block';
      });
    }
    if (readLessButton) {
      readLessButton.addEventListener('click', (event) => {
        event.preventDefault();
        shortDescription.style.display = 'block';
        fullDescription.style.display = 'none';
      });
    }
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const tabLinks = document.querySelectorAll('.tablinks');
  const tabContents = document.querySelectorAll('.tabcontent');

  tabLinks.forEach((tab) => {
    tab.addEventListener('click', (event) => {
      event.preventDefault();

      tabLinks.forEach((link) => link.classList.remove('active'));
      tabContents.forEach((content) => content.classList.remove('active'));

      tab.classList.add('active');
      const targetContent = document.getElementById(tab.dataset.tab);
      targetContent.classList.add('active');
    });
  });
 
  const firstOptionValue = document.querySelector('.option-cart-value');
  const detail_dropdown = document.querySelector('.details-dropdown');
  if (firstOptionValue) {
      firstOptionValue.classList.remove('hidden');
  }
  if (detail_dropdown) {
    detail_dropdown.classList.remove('active');
  }
  document.body.addEventListener('click', (event) => {
    if (event.target.classList.contains('details-dropdown')) {
      const dropdownWrapper = event.target.closest('.option-dropdown-wrapper');
      const optionValue = dropdownWrapper.querySelector('.option-cart-value');
      if (optionValue) {
        optionValue.classList.toggle('hidden');
        event.target.classList.toggle('active');
      }
    }
  });   

  // const headings = document.querySelectorAll('.collapsible-trigger-heading');
  // headings.forEach(heading => {
  //   heading.addEventListener('click', function () {
  //     headings.forEach(h => h.classList.remove('active'));
  //     this.classList.add('active');

  //     const targetId = this.getAttribute('data-target');
  //     const targetElement = document.getElementById(targetId);

  //     if (targetElement) {
  //       targetElement.scrollIntoView({ behavior: 'smooth' });
  //     }
  //   });
  // });
  const headings = document.querySelectorAll('.collapsible-trigger-heading');
  headings.forEach(heading => {
    heading.addEventListener('click', function () {
      headings.forEach(h => h.classList.remove('active'));
      this.classList.add('active');
      const targetId = this.getAttribute('data-target');
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        const header = document.querySelector('.shopify-section-header-hidden');
        const headerHeight = header ? header.offsetHeight : 0;
        const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY - headerHeight;
        window.scrollTo({
          top: elementPosition,
          behavior: 'smooth',
        });
      }
    });
  });

  const dropdown = document.getElementById('faq-dropdown');
  const toggleButton = dropdown.querySelector('.faq-dropdown-toggle');
  const menu = dropdown.querySelector('.faq-dropdown-menu');
  const items = dropdown.querySelectorAll('.faq-dropdown-item');

  toggleButton.addEventListener('click', function () {
    menu.classList.toggle('visible');
  });

  items.forEach(item => {
    item.addEventListener('click', function () {
      const selectedValue = this.getAttribute('data-value');
      toggleButton.textContent = this.textContent;
      menu.classList.remove('visible'); 

      const targetHeading = document.getElementById(selectedValue);
      if (targetHeading) {
        targetHeading.scrollIntoView({ behavior: 'smooth' });
        document.querySelectorAll('.faq-heading').forEach(heading => heading.classList.remove('active'));
        targetHeading.classList.add('active');
      }
    });
  });

  // Close the menu if clicked outside
  document.addEventListener('click', function (event) {
    if (!dropdown.contains(event.target)) {
      menu.classList.remove('visible');
    }
  });


});


